module.exports = __webpack_public_path__ + "img/logo-elaqat.71ecace1.png";